import { TitleBlockTemplate } from '@/app/types/titleblock';
import { DEFAULT_TEMPLATE_ID, getFahnerTemplate } from '@/app/components/plans/fahnerTemplate';

const STORAGE_KEY = 'iso_block_title_templates_v1';

// Initial default templates
const BUILTIN_TEMPLATES: TitleBlockTemplate[] = [
  getFahnerTemplate(), // The default empty one
];

export const TitleBlockStorage = {
  getTemplates: (): TitleBlockTemplate[] => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      const custom: TitleBlockTemplate[] = stored ? JSON.parse(stored) : [];
      return [...BUILTIN_TEMPLATES, ...custom];
    } catch (e) {
      console.error('Failed to load title block templates', e);
      return BUILTIN_TEMPLATES;
    }
  },

  saveTemplate: (template: TitleBlockTemplate) => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      let custom: TitleBlockTemplate[] = stored ? JSON.parse(stored) : [];
      
      // Update if exists, or add new
      const idx = custom.findIndex(t => t.id === template.id);
      if (idx >= 0) {
        custom[idx] = template;
      } else {
        custom.push(template);
      }
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(custom));
    } catch (e) {
      console.error('Failed to save title block template', e);
    }
  },

  deleteTemplate: (id: string) => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return;
      
      let custom: TitleBlockTemplate[] = JSON.parse(stored);
      custom = custom.filter(t => t.id !== id);
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(custom));
    } catch (e) {
      console.error('Failed to delete title block template', e);
    }
  }
};
